import { getFeatureFlags } from '../../../../../lib/config/multitenancy.js'
import { hasTokenPermission } from '../../../../../stores/authStore.js'
import { MANAGE_TRANSLATIONS_PERMISSION } from '../../../translations/lib/translationConstants.js'

const AVAILABLE_RESOURCE_OPTIONS = [
  { text: 'Users', href: '/admin/users', icon: 'users' },
  { text: 'Companies', href: '/admin/companies', icon: 'building' },
  { text: 'Markets', href: '/admin/markets', icon: 'globe' },
  { text: 'Places', href: '/admin/places', icon: 'map marker' },
]

export const useAdminSidebarLogic = () => ({
  resourceOptions: AVAILABLE_RESOURCE_OPTIONS,
  showNotifications: !!getFeatureFlags().admin_notifications,
  showTranslations: hasTokenPermission(MANAGE_TRANSLATIONS_PERMISSION),
})
